import { pitchMediaTypeByID, pitchMediaTypeCreate, pitchMediaTypeDestroy, pitchMediaTypeList, pitchMediaTypeUpdate } from '@/services/ventures/pitch-media-types.service'

export default {
	namespaced: true,
	state: {
		pitchMediaTypeList: { meta: { pagination: { total: 0 } } },
		pitchMediaType: {},
		pitchMediaTypeStatus: 'pending',
		pitchMediaTypeSaveStatus: 'init',
		pitchMediaTypeDeleteStatus: 'init',
	},
	getters: {
		getPitchMediaTypeList: s => s.pitchMediaTypeList,
		getPitchMediaType: s => s.pitchMediaType,
		getPitchMediaTypeStatus: s => s.pitchMediaTypeStatus,
		getPitchMediaTypeSaveStatus: s => s.pitchMediaTypeSaveStatus,
		getPitchMediaTypeDeleteStatus: s => s.pitchMediaTypeDeleteStatus,
	},
	mutations: {
		PITCH_MEDIA_TYPE_LIST(state, value) { state.pitchMediaTypeList = value },
		SET_PITCH_MEDIA_TYPE(state, value) { state.pitchMediaType = value },
		PITCH_MEDIA_TYPE_STATUS(state, value) { state.pitchMediaTypeStatus = value },
		PITCH_MEDIA_TYPE_SAVE_STATUS(state, value) { state.pitchMediaTypeSaveStatus = value },
		PITCH_MEDIA_TYPE_DELETE_STATUS(state, value) { state.pitchMediaTypeDeleteStatus = value },
	},
	actions: {
		async fetchPitchMediaTypeList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('PITCH_MEDIA_TYPE_STATUS', 'pending')
			commit('PITCH_MEDIA_TYPE_LIST', { meta: { pagination: { total: 0 } } })
			try {
				const { data } = await pitchMediaTypeList(params)
				commit('PITCH_MEDIA_TYPE_STATUS', 'init')
				commit('PITCH_MEDIA_TYPE_LIST', data)
				return data
			} catch (error) {
				commit('PITCH_MEDIA_TYPE_STATUS', 'init')
				throw error
			}
		},
		async savePitchMediaType({ commit }, params) {
			commit('PITCH_MEDIA_TYPE_SAVE_STATUS', 'pending')
			try {
				const { data } = await pitchMediaTypeCreate(params)
				commit('PITCH_MEDIA_TYPE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('PITCH_MEDIA_TYPE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updatePitchMediaType({ commit }, params) {
			commit('PITCH_MEDIA_TYPE_SAVE_STATUS', 'pending')
			try {
				const { data } = await pitchMediaTypeUpdate(params)
				commit('PITCH_MEDIA_TYPE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('PITCH_MEDIA_TYPE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deletePitchMediaTypeByID({ commit }, params) {
			commit('PITCH_MEDIA_TYPE_DELETE_STATUS', 'pending')
			try {
				const { data } = await pitchMediaTypeDestroy(params)
				commit('PITCH_MEDIA_TYPE_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('PITCH_MEDIA_TYPE_DELETE_STATUS', 'error')
				return error
			}
		},
	},
}
